import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { Button, Input, Spin } from 'antd';
import { modelUtils } from '@/utils';
import './index.less'
const { WizContainer } = framework_tool;
const { WizModal } = component_tool;

const { TextArea } = Input;

class WizPhoneCall extends WizContainer {
  componentName = "WizPhoneCall";

  constructor(props) {
    super(props);
    log.info('props', props);
    this.state = {
      visible: false,
      haveTelSeats: true,
      seatsMsg: {},
      phoneShow: false,
      phoneUser: {},
      questionNo: '',
      recordId: '',
      recordFileId: '',
      remark: '',
      initBol: true,
      loading: true,
      closeType: '',
    };
  }

  propsAndStateOnChange = {
    getYunTelSeats: this._getYunTelSeatsOver.bind(this),
    getUserPhoneNum: this._getUserPhoneNumOver.bind(this),
    addYunTelRecord: this._addYunTelRecordOver.bind(this),
    addYunTelRecordFile: this._addYunTelRecordFileOver.bind(this),
    updateYunTelRecord: this._updateYunTelRecordOver.bind(this),
    seatsLoginOut: this._seatsLoginOutOver.bind(this),
    searchLocState: this._searchLocStateOver.bind(this),
  }

  _componentDidMount = () => {
    this._getYunTelSeats();
    this.setState({ initBol: false })
    let { innerQues, record } = this.props
    if (!innerQues) {
      this._getUserPhoneNum();
    } else {
      this.setState({ phoneUser: record })
    }
  };

  _getUserPhoneNumOver(nextProps, nextState) {
    if (nextProps.getUserPhoneNum.success && nextProps.getUserPhoneNum.data) {
      nextState.phoneUser = nextProps.getUserPhoneNum.data.user;
    } else {
      wizNotice.error(nextProps.getUserPhoneNum.msg);
    }
    return true;
  }

  _getYunTelSeatsOver(nextProps, nextState) {
    if (nextProps.getYunTelSeats.success && nextProps.getYunTelSeats.data) {
      nextState.haveTelSeats = true
      nextState.seatsMsg = nextProps.getYunTelSeats.data;
      this.addScripot()
      setTimeout(() => {
        this.phoneLogin(nextProps.getYunTelSeats.data)
      }, 1000);
    } else {
      nextState.haveTelSeats = false
      nextState.loading = false
      wizNotice.error(nextProps.getYunTelSeats.msg);
    }
    return true;
  }

  _addYunTelRecordOver(nextProps, nextState) {
    if (nextProps.addYunTelRecord.success && nextProps.addYunTelRecord.data) {
      nextState.recordId = nextProps.addYunTelRecord.data;
    } else {
      wizNotice.error(nextProps.addYunTelRecord.msg);
    }
    return true;
  }
  _addYunTelRecordFileOver(nextProps, nextState) {
    if (nextProps.addYunTelRecordFile.success && nextProps.addYunTelRecordFile.data) {
      nextState.recordFileId = nextProps.addYunTelRecordFile.data;
    } else {
      wizNotice.error(nextProps.addYunTelRecordFile.msg);
    }
    return true;
  }
  _updateYunTelRecordOver(nextProps, nextState) {
    if (nextProps.updateYunTelRecord.success && nextProps.updateYunTelRecord.data) {
      let params = { logoutMode: 1, removeBinding: 0 }
      this.clinkToolbar = null
      ClinkAgent.logout(params);
      this._seatsLoginOut({ cno: nextState.seatsMsg.cno })
    } else {
      wizNotice.error(nextProps.updateYunTelRecord.msg);
    }
    return true;
  }

  _seatsLoginOutOver(nextProps, nextState) {
    let { closeModal } = nextProps
    if (nextProps.seatsLoginOut.success && nextProps.seatsLoginOut.data) {
      nextState.loading = false
      closeModal()
    } else {
      wizNotice.error(nextProps.seatsLoginOut.msg);
    }
    return true;
  }
  _searchLocStateOver(nextProps, nextState) {
    if (nextProps.searchLocState.success && nextProps.searchLocState.data) {
      let { agentStatusDetail } = nextProps.searchLocState.data
      if (agentStatusDetail?.status != 'CALLING' && agentStatusDetail?.status != 'BUSY' && agentStatusDetail?.status != 'RINGING') {
        let { remark, recordId, closeType } = nextState
        // if (closeType == 'submit') {
          let { record, parentEntityId } = nextProps
          let params = {
            entityId: record.id,
            contactPerson: record.personId,
            remark,
            id: recordId
          }
          if (parentEntityId) {
            params.parentEntityId = parentEntityId
          }
          this._updateYunTelRecord(params)
        // } else {
        //   ClinkAgent.setup({ sipPhone: false, debug: false }, function () {
        //     // 注册退出响应回调方法
        //     ClinkAgent.registerCallback(ClinkAgent.ResponseType.LOGOUT, function (result) {
        //       if (result.code === 0) {
        //         console.log('退出成功')
        //         // 退出成功
        //       } else {
        //         console.log('退出失败')
        //         // 退出失败
        //       }
        //     });
        //   });
        //   let params = { logoutMode: 1, removeBinding: 0 }
        //   this.clinkToolbar = null
        //   ClinkAgent.logout(params);
        //   this._seatsLoginOut({ cno: this.state.seatsMsg.cno })
        // }
      } else {
        wizNotice.error('当前正在呼叫中或通话，请挂断后退出');
        nextState.loading = false
      }

    } else {
      wizNotice.error(nextProps.searchLocState.msg);
    }
    return true;
  }

  _getUserPhoneNum = () => {
    let { personId = '' } = this.props.record
    this.doAction({
      path: 'smartPhone/getUserPhoneNum',
      payload: {
        key: "getUserPhoneNum",
        apiParams: {
          personId: personId
        }
      }
    });
  }

  _getYunTelSeats = () => {
    this.doAction({
      path: 'smartPhone/getYunTelSeats',
      payload: {
        key: "getYunTelSeats",
        apiParams: {

        }
      }
    });
  }

  _addYunTelRecord = (params) => {
    let { entityType, callScene, record } = this.props
    this.doAction({
      path: 'smartPhone/addYunTelRecord',
      payload: {
        key: "addYunTelRecord",
        apiParams: {
          callingParty: storage.getStorage('user').personId,
          state: 0,
          entityType,
          callScene,
          ltemNumber: record.qIndex,
          ...params,
        }
      }
    });
  }

  _updateYunTelRecord = (params) => {
    let { entityType, callScene, record } = this.props
    this.doAction({
      path: 'smartPhone/updateYunTelRecord',
      payload: {
        key: "updateYunTelRecord",
        apiParams: {
          callingParty: storage.getStorage('user').personId,
          state: 1,
          entityType,
          callScene,
          ltemNumber: record.qIndex,
          ...params,
        }
      }
    });
  }

  _addYunTelRecordFile = (params) => {
    let { recordId } = this.state
    this.doAction({
      path: 'smartPhone/addYunTelRecordFile',
      payload: {
        key: "addYunTelRecordFile",
        apiParams: {
          recordId,
          state: 0,
          ...params,
        }
      }
    });
  }

  _updateYunTelRecordFile = (params) => {
    let { recordId, recordFileId } = this.state
    this.doAction({
      path: 'smartPhone/updateYunTelRecordFile',
      payload: {
        key: "updateYunTelRecordFile",
        apiParams: {
          id: recordFileId,
          recordId,
          state: 1,
          ...params,
        }
      }
    });
  }

  _seatsLoginOut = (params) => {
    this.doAction({
      path: 'smartPhone/seatsLoginOut',
      payload: {
        key: "seatsLoginOut",
        apiParams: {
          ...params
        }
      }
    });
  }

  _searchLocState = (params) => {
    this.doAction({
      path: 'smartPhone/searchLocState',
      payload: {
        key: "searchLocState",
        apiParams: {
          ...params
        }
      }
    });
  }

  addScripot = () => {
    if (this.scripts?.length) {
      document.head.removeChild(this.scripts[0])
      document.head.removeChild(this.scripts[1])
    }
    let a = document.createElement('script')
    a.src = 'https://ws-bj.clink.cn/clink-client.js?id=wizlong'
    let b = document.createElement('script')
    b.src = 'https://ws-bj.clink.cn/clink-client-ui-vue/ClinkToolbar.umd.min.js'
    document.head.appendChild(a)
    document.head.appendChild(b)
    this.scripts = [a, b]
  }

  /**
     * 云电话登录
     */
  phoneLogin = (seats) => {
    const options = {
      isAutoLogin: true, // 展示登录界面
      // 隐藏登录界面中的部分版块配置
      toolbarMsgShowConfiguration: {
        showTelInput: false, // 登录状态下是否显示号码输入框、默认为true
        showCallingBth: false, // 登录状态下是否显示呼叫按钮、默认为true
        showLogout: false,
      },
      // 话务管理配置
      showHold: false, // 支持保持
      showConsult: false, //支持咨询,
      showTransfer: false, //支持转移
      showSatisfaction: false, //支持满意度
      showMute: true, //支持静音
      debug: true // 是否开启debug 默认开启
    };
    const dom = document.getElementById('toolbar');
    console.log('电话条初始化:', dom);
    let clinkToolbar = this.clinkToolbar ? this.clinkToolbar : new ClinkToolbar(options, dom, () => {
      console.log('电话条初始化完成');
      this.clinkToolbar = clinkToolbar;
    });

    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.STATUS, e => {
      console.log('座席状态事件回调:', e);
      storage.setStorage('locCno', seats.cno);
      this.setState({ loading: false })
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.PREVIEW_OUTCALL_RINGING, e => {
      console.log('预览外呼客户响铃事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.PREVIEW_OUTCALL_BRIDGE, e => {
      console.log('预览外呼客户接听事件回调:', e);
      let params = { thirdId: e.mainUniqueId }
      this._updateYunTelRecordFile(params)
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.CONSULT_START, e => {
      console.log('咨询开始事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.CONSULT_LINK, e => {
      console.log('咨询接听事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.CONSULT_ERROR, e => {
      console.log('咨询失败事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.UNCONSULT, e => {
      console.log('咨询挂断/接回/取消事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.CONSULT_THREEWAY, e => {
      console.log('咨询三方事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.CONSULT_THREEWAY_UNLINK, e => {
      console.log('咨询三方挂断事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.CONSULT_TRANSFER, e => {
      console.log('咨询转移事件回调:', e);
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.RINGING, e => {
      console.log('响铃事件回调:', e);
      let params = { thirdId: e.mainUniqueId, startTime: e.startTime }
      this._addYunTelRecordFile(params)
    });
    clinkToolbar.userCustomEvent.on(ClinkAgent.EventType.KICKOUT, e => {
      console.log('被踢下线事件回调:', e);
    });

    // 注册只监听一次的事件
    clinkToolbar.userCustomEvent.once(ClinkAgent.EventType.STATUS, e => {
      console.log('座席状态事件回调:', e);
    });
    const params = {
      ...seats,
      identifier: 'wizlong',
      loginStatus: 1,
    };
    ClinkAgent.login(params);
    let { parentEntityId, record } = this.props
    let addParams = {
      entityId: record.id,
      contactPerson: record.personId,
    }
    if (parentEntityId) {
      addParams.parentEntityId = parentEntityId
    }
    this._addYunTelRecord(addParams)
  }

  onCall = (phoneUser = this.state.phoneUser) => {
    if (!phoneUser.mobile) {
      wizNotice.warn('电话号码异常，请确认后重试')
    } else if (!ClinkAgent || !this.clinkToolbar) {
      wizNotice.warn('请先登录云电话！')
    } else {
      ClinkAgent && ClinkAgent.previewOutcall({
        //tel:'021-38279957'
        tel: phoneUser.mobile + ''
      });
    }
  }

  seatsOutClose = () => {
    this.setState({ loading: true }, () => {
      let { haveTelSeats } = this.state
      let { closeModal } = this.props
      if (haveTelSeats) {
        this._searchLocState({ cno: this.state.seatsMsg.cno })
      } else {
        this.setState({ loading: false })
        closeModal()
      }
    })
  }

  onSubmit = (type) => {
    this.setState({ loading: true, closeType: 'submit' }, () => {
      let { closeModal } = this.props
      if (type == 1) {
        this._searchLocState({ cno: this.state.seatsMsg.cno })
      } else {
        this.setState({ loading: false })
        closeModal()
      }
    })
  }
  textChange = (e) => {
    this.setState({ remark: e.target.value })
  }
  _render() {
    const { phoneUser, remark, haveTelSeats, loading } = this.state
    const { modalShow } = this.props
    return (
      <React.Fragment>
        <WizModal visible={modalShow} title={'语音通话'} width={450} footer={null} onCancel={() => this.seatsOutClose()}>
          <Spin spinning={loading} tip="Loading...">
            <div className="wiz-phone-call">
              {haveTelSeats ?
                <div>
                  <div className="phone-call-title">拨号信息</div>
                  <div className="phone-msg-box">
                    <div className="msg-left">
                      <span>{phoneUser.fullName}</span>
                      {phoneUser.qIndex ? <span className="msg-left-num">题目序号({phoneUser.qIndex})</span> : null}
                    </div>
                    <div className="msg-right">
                      <Button type="primary" onClick={() => { this.onCall(phoneUser) }}>拨打</Button>
                    </div>
                  </div>
                  <div className="phone-call-title">电话条</div>
                  <div className="phone-box">
                    <div style={{ padding: 10 }} id='toolbar'></div>
                  </div>
                  <div className="phone-call-title">备注</div>
                  <div className="remark-box">
                    <TextArea rows={5} value={remark} onChange={(e) => this.textChange(e)} maxLength={200} />
                  </div>
                  <div className="submit-box">
                    <Button type="primary" onClick={() => this.seatsOutClose()}>确认并关闭</Button>
                  </div>
                </div>
                :
                <div>
                  <div>当前无可用坐席或您的电话已登入</div>
                  <div className="submit-box">
                    <Button onClick={() => this.seatsOutClose()}>关闭</Button>
                  </div>
                </div>
              }
            </div>
          </Spin>
        </WizModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { smartPhone } = state;
  const getYunTelSeats = modelUtils.getModelEntity(smartPhone, 'getYunTelSeats');
  const getUserPhoneNum = modelUtils.getModelEntity(smartPhone, 'getUserPhoneNum');
  const addYunTelRecord = modelUtils.getModelEntity(smartPhone, 'addYunTelRecord');
  const updateYunTelRecord = modelUtils.getModelEntity(smartPhone, 'updateYunTelRecord');
  const addYunTelRecordFile = modelUtils.getModelEntity(smartPhone, 'addYunTelRecordFile');
  const updateYunTelRecordFile = modelUtils.getModelEntity(smartPhone, 'updateYunTelRecordFile');
  const seatsLoginOut = modelUtils.getModelEntity(smartPhone, 'seatsLoginOut');
  const searchLocState = modelUtils.getModelEntity(smartPhone, 'searchLocState');

  return {
    getYunTelSeats,
    getUserPhoneNum,
    addYunTelRecord,
    updateYunTelRecord,
    addYunTelRecordFile,
    updateYunTelRecordFile,
    seatsLoginOut,
    searchLocState,
  }
};

export default connect(mapStateToProps)(WizPhoneCall);
